// @core/api/endpoints/admin/get_admin_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AdminSettingsResponse,
} from '../../../types/admin';

const BASE_PATH = '/admin';

/**
 * Get admin settings
 * Retrieves platform-level administrative settings including maintenance mode configuration, system notifications, and security policies.
 */
export async function GetAdminSettings(
  params?: {
  },
  options?: RequestOptions
): Promise<AdminSettingsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/admin/settings`;
  const requestOptions = options;
  return client.get<AdminSettingsResponse>(requestPath, { ...requestOptions, params });
}
